import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ProductHeroLayout from './ProductHeroLayout';
import Button from '../modules/components/Button';
import 'animate.css';
import cssUrl from '../modules/components/cssUrl';

const backgroundImage = '/images/background_light.jpg';

/** 右下の縦書きラベル（SP では非表示）。 */
const established = (
  <Box
    sx={{
      // 900px 未満はコピーブロックと重なるため出さない
      display: { xs: 'none', md: 'block' },
      position: 'absolute',
      right: 48,
      bottom: 88,
      zIndex: 2,
      writingMode: 'vertical-rl',
      fontFamily: "'Noto Serif JP', serif",
      fontSize: 13,
      letterSpacing: '.42em',
      color: 'rgba(255,255,255,.85)',
      borderRight: '1px solid rgba(255,255,255,.4)',
      pr: 1.75,
    }}
  >
    昭和四十二年創業 ─ 埼玉・入間
  </Box>
);

export default function ProductHero() {
  return (
    <ProductHeroLayout
      aside={established}
      sxBackground={{
        backgroundImage: cssUrl(backgroundImage),
        backgroundColor: '#7fc7d9', // 画像読み込み前の平均色
      }}
    >
      <Box className="animate__animated animate__fadeInUp">
        <Typography
          variant="h1"
          component="h1"
          sx={{ color: 'inherit', mb: 2.5, textShadow: '0 1px 24px rgba(0,0,0,.3)' }}
        >
          建築士と、
          <br />
          一緒につくる家。
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: 14, sm: 16 },
            fontWeight: 300,
            letterSpacing: '.12em',
            color: 'rgba(255,255,255,.92)',
            mb: { xs: 4, sm: 5 },
          }}
        >
          設計から庭、インテリアまで。資格を持つスタッフが、ひとつの手で家づくりを描きます。
        </Typography>
        <Box
          sx={{
            display: 'flex',
            gap: { xs: 1.5, sm: 2 },
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'flex-start', sm: 'center' },
          }}
        >
          <Button href="/contact">見積・相談 無料</Button>
          <Button tone="ghost" href="/case">
            施工事例を見る
          </Button>
        </Box>
      </Box>
    </ProductHeroLayout>
  );
}
